// Tier + total helper — mirrors backend calc_quote 3-day minimum & tier bands.
// Whole-dollar policy: per-day rates are floored (round DOWN, customer-favorable)
// so displayed prices always match what Stripe charges.
export const MIN_RENTAL_SUBTOTAL = 50;

export const computeRentalPrice = (p, range) => {
  if (!p || !range?.from || !range?.to) return null;
  const msPerDay = 1000 * 60 * 60 * 24;
  const actualDays = Math.max(1, Math.round((range.to - range.from) / msPerDay) + 1);
  const billableDays = Math.max(3, actualDays);
  const rawRate = billableDays <= 3
    ? (p.tier_1_3 ?? p.price_per_day)
    : billableDays <= 7
      ? (p.tier_4_7 ?? p.price_per_day)
      : (p.tier_8_plus ?? p.price_per_day);
  const rate = Math.floor(Number(rawRate) || 0);
  return {
    actualDays,
    billableDays,
    rate,
    total: rate * billableDays,
    isMinApplied: actualDays < 3,
  };
};

// Build-Your-Own Bundle progress for the current cart. `byob` = { enabled, percent, minUnits }.
export const computeByob = (byob, products, cart) => {
  if (!byob?.enabled) return null;
  const units = Object.entries(cart || {}).reduce((sum, [pid, qty]) => {
    const p = (products || []).find((x) => x.id === pid);
    return p?.byob_eligible ? sum + Number(qty || 0) : sum;
  }, 0);
  const minUnits = Number(byob.minUnits) || 3;
  return { units, minUnits, remaining: Math.max(0, minUnits - units), qualified: units >= minUnits, percent: Number(byob.percent) || 0 };
};
